module.exports = __webpack_public_path__ + "static/services2-7de54c4db25f8d40a6aa313860dcf3b2.png";